import { createReducer } from '@reduxjs/toolkit';
import { addError, removeError } from './action';
import type { MetaDataState } from './state';
import initialMetaDataState from './state';

export const metaDataReducer = createReducer<MetaDataState>(
  initialMetaDataState,
  (builder) => {
    builder.addCase(addError, (state) => ({
      ...state,
      hasError: true,
    }));

    builder.addCase(removeError, (state) => ({
      ...state,
      hasError: false,
    }));
  },
);
